import { FilterState } from '../../types';

export const calculateActiveFilterCount = (filterState: FilterState): number => {
  let count = 0;
  if (filterState.health.length) count++;
  if (filterState.owner.length) count++;
  if (filterState.client.length) count++;
  if (filterState.business.length) count++;
  if (filterState.dealType.length) count++;
  if (filterState.startDate !== null || filterState.closeDate !== null) count++;
  return count;
};

export const hasActiveFilters = (filterState: FilterState): boolean => {
  return calculateActiveFilterCount(filterState) > 0;
};
